import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type BolexActivatedPayload = {
  bolus_id: number;
  iob?: number;
  bolex_size?: number;
};

export type BolexActivatedEvent = {
  bolusId: number;
  iob?: number;
  bolexSize?: number;
};

const bolexActivatedSchema = z.object({
  bolus_id: z.number(),
  iob: cz.permissive(z.number()),
  bolex_size: cz.permissive(z.number()),
});

export const LID_BOLEX_ACTIVATED = {
  value: 0x3b,
  name: "Extended Bolus Activated Event",
  format: "h..ff....",
  fields: ["bolus_id", "iob", "bolex_size"],
  postprocess: rec => ({
    bolusId: rec.bolus_id,
    iob: rec.iob,
    bolexSize: rec.bolex_size,
  }),
  schema: bolexActivatedSchema,
} as const satisfies TandemEventDefinition<BolexActivatedPayload, BolexActivatedEvent>;
